import { ErrorMessage, Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import { PatternFormat } from 'react-number-format';
import { SingleSelect } from '../../../baseComponents';
import { useSelector } from 'react-redux';
import './Organization.scss';
import { getMirrorPractitionerDetails } from 'src/modules/SuperAdmin/store/actions/organization.action';
import { useDispatch } from 'react-redux';
import moment from 'moment';

// eslint-disable-next-line react/display-name
export const OrganizationFields = React.forwardRef(
  (
    {
      isEditPage,
      orgData,
      setOrgData,
      validationSchema,
      ehrFilterOrganizationList,
      setPreferredAreaCodes,
      preferredAreaCodes,
      inputValue,
      setInputValue,
      setJsonInput,
      setNotificationStartHour,
      setNotificationStartMinute,
      setNotificationEndHour,
      setNotificationEndMinute,
      setNotificationStartRadio,
      setNotificationsEndRadio,
    },
    formRef
  ) => {
    const [isExpandedAddress, setIsExpandedAddress] = useState(false);

    const { fronteggPlans, getActiveOrganizationsList, organizationLoading } =
      useSelector((state) => state?.organizationState);

    const [fronteggPlanOptions, setFronteggPlanOptions] = useState([]);
    const [organizationDropdown, setOrganizationDropdown] = useState([]);

    const [isMirrorOrg, setIsMirrorOrg] = useState(false);

    const [flipicon, setflipicon] = useState(<DownOutlined />);
    const addressToggleVisibility = () => {
      setIsExpandedAddress(!isExpandedAddress);
      setflipicon(isExpandedAddress ? <DownOutlined /> : <UpOutlined />);
    };
    const handleKeyDown = (e) => {
      const value = e.target.value;
      // Navigate up to find the container that holds the error messages
      const container =
        e.target.closest('.selector') ||
        e.target.parentElement.parentElement.parentElement;
      const errMsgElement = container.querySelector(
        '[name="preferred_phone_area_codes_errMsg"]'
      );
      const requiredMsgElement = container.querySelector(
        '[name="preferred_phone_area_codes_requiredMsg"]'
      );

      if (value.length === 0) {
        requiredMsgElement.classList.remove('hidden');
        errMsgElement.classList.add('hidden');
      } else {
        requiredMsgElement.classList.add('hidden');

        if (value.length !== 3 || isNaN(Number(value))) {
          errMsgElement.classList.remove('hidden');
        } else {
          errMsgElement.classList.add('hidden');
        }
      }
    };

    const usStateOptions = [
      { label: 'Alabama', value: 'Alabama' },
      { label: 'Alaska', value: 'Alaska' },
      { label: 'Arizona', value: 'Arizona' },
      { label: 'Arkansas', value: 'Arkansas' },
      { label: 'California', value: 'California' },
      { label: 'Colorado', value: 'Colorado' },
      { label: 'Connecticut', value: 'Connecticut' },
      { label: 'Delaware', value: 'Delaware' },
      { label: 'Florida', value: 'Florida' },
      { label: 'Georgia', value: 'Georgia' },
      { label: 'Hawaii', value: 'Hawaii' },
      { label: 'Idaho', value: 'Idaho' },
      { label: 'Illinois', value: 'Illinois' },
      { label: 'Indiana', value: 'Indiana' },
      { label: 'Iowa', value: 'Iowa' },
      { label: 'Kansas', value: 'Kansas' },
      { label: 'Kentucky', value: 'Kentucky' },
      { label: 'Louisiana', value: 'Louisiana' },
      { label: 'Maine', value: 'Maine' },
      { label: 'Maryland', value: 'Maryland' },
      { label: 'Massachusetts', value: 'Massachusetts' },
      { label: 'Michigan', value: 'Michigan' },
      { label: 'Minnesota', value: 'Minnesota' },
      { label: 'Mississippi', value: 'Mississippi' },
      { label: 'Missouri', value: 'Missouri' },
      { label: 'Montana', value: 'Montana' },
      { label: 'Nebraska', value: 'Nebraska' },
      { label: 'Nevada', value: 'Nevada' },
      { label: 'New Hampshire', value: 'New Hampshire' },
      { label: 'New Jersey', value: 'New Jersey' },
      { label: 'New Mexico', value: 'New Mexico' },
      { label: 'New York', value: 'New York' },
      { label: 'North Carolina', value: 'North Carolina' },
      { label: 'North Dakota', value: 'North Dakota' },
      { label: 'Ohio', value: 'Ohio' },
      { label: 'Oklahoma', value: 'Oklahoma' },
      { label: 'Oregon', value: 'Oregon' },
      { label: 'Pennsylvania', value: 'Pennsylvania' },
      { label: 'Rhode Island', value: 'Rhode Island' },
      { label: 'South Carolina', value: 'South Carolina' },
      { label: 'South Dakota', value: 'South Dakota' },
      { label: 'Tennessee', value: 'Tennessee' },
      { label: 'Texas', value: 'Texas' },
      { label: 'Utah', value: 'Utah' },
      { label: 'Vermont', value: 'Vermont' },
      { label: 'Virginia', value: 'Virginia' },
      { label: 'Washington', value: 'Washington' },
      { label: 'West Virginia', value: 'West Virginia' },
      { label: 'Wisconsin', value: 'Wisconsin' },
      { label: 'Wyoming', value: 'Wyoming' },
    ];
    const pageTitle = isEditPage ? 'Edit organization' : 'Add organization';

    const dispatch = useDispatch();

    useEffect(() => {
      if (
        getActiveOrganizationsList &&
        Array.isArray(getActiveOrganizationsList) &&
        getActiveOrganizationsList.length > 0
      ) {
        let dataArr = [];
        getActiveOrganizationsList.forEach((key) => {
          // Ensure we have valid org_id and org_name before adding to dropdown
          // Also check for alternative field names that might be used
          const orgId = key?.org_id || key?.id || key?.organization_id;
          const orgName = key?.org_name || key?.name || key?.organization_name;
          const orgUuid = key?.org_uuid || key?.uuid || key?.organization_uuid;

          if (
            orgId &&
            orgName &&
            typeof orgName === 'string' &&
            orgName.trim() !== ''
          ) {
            dataArr.push({
              value: orgId,
              label: orgName.trim(),
              org_uuid: orgUuid,
            });
          }
        });
        setOrganizationDropdown(dataArr);
      } else {
        // Reset to empty array if no valid data
        setOrganizationDropdown([]);
      }
    }, [getActiveOrganizationsList]);

    useEffect(() => {
      if (fronteggPlans && Array.isArray(fronteggPlans)) {
        let dataArr = [];
        fronteggPlans.forEach((key, index) => {
          dataArr.push({
            value: key?.id,
            label: key?.name,
          });
        });
        setFronteggPlanOptions(dataArr);
      }
    }, [fronteggPlans]);

    const handleRemoveCode = (indexToRemove) => {
      setPreferredAreaCodes(
        preferredAreaCodes.filter((code, index) => index !== indexToRemove)
      );
    };

    const autoPopulateTimeFields = (startTime, endTime) => {
      const browserTimezone = moment.tz.guess();
      const startHour = startTime || '';
      const endHour = endTime || '';

      if (startHour && endHour) {
        const [split_start_hour, split_start_minute] = startHour.split(':');
        const [split_end_hour, split_end_minute] = endHour.split(':');

        const startMoment = moment
          .utc(`${split_start_hour}:${split_start_minute}`, 'HH:mm')
          .tz(browserTimezone);
        const endMoment = moment
          .utc(`${split_end_hour}:${split_end_minute}`, 'HH:mm')
          .tz(browserTimezone);

        const local_start_hours = startMoment.hours();
        const local_end_hours = endMoment.hours();

        let default_start_hour = local_start_hours;
        let default_end_hour = local_end_hours;

        if (default_start_hour) {
          const parsedHour = parseInt(default_start_hour);
          if (!isNaN(parsedHour) && parsedHour >= 0 && parsedHour <= 11) {
            setNotificationStartRadio(1);
          } else {
            setNotificationStartRadio(2);
          }
        }

        if (default_end_hour) {
          const parsedHour = parseInt(default_end_hour);
          if (!isNaN(parsedHour) && parsedHour >= 0 && parsedHour <= 11) {
            setNotificationsEndRadio(1);
          } else {
            setNotificationsEndRadio(2);
          }
        }

        if (local_start_hours === 0) {
          default_start_hour = 12; // Midnight is represented as 12 AM
        } else if (local_start_hours > 12) {
          default_start_hour = local_start_hours - 12;
        }

        if (local_end_hours === 0) {
          default_end_hour = 12; // Midnight is represented as 12 AM
        } else if (local_end_hours > 12) {
          default_end_hour = local_end_hours - 12;
        }

        setNotificationStartMinute(
          startMoment.minutes() < 10
            ? '0' + startMoment.minutes()
            : startMoment.minutes()
        );
        setNotificationStartHour(default_start_hour);

        setNotificationEndMinute(
          endMoment.minutes() < 10
            ? '0' + endMoment.minutes()
            : endMoment.minutes()
        );
        setNotificationEndHour(default_end_hour);
      }
    };
    return (
      <Formik
        initialValues={orgData}
        enableReinitialize
        validationSchema={validationSchema}
        innerRef={formRef}
        onSubmit={() => {}}
      >
        {({ handleSubmit, setFieldValue, values }) => (
          <>
            <Form onSubmit={handleSubmit} autoComplete="off">
              <>
                <div className="organization">
                  <div>
                    <div className="flex  text-lg font-semibold mb-2 text-[#000]">
                      {pageTitle}
                    </div>
                    {isEditPage ? (
                      <div className="">
                        <div className="mt-4 ml-1">
                          <span
                            className="justify-center font-normal text-sm text-black items-center whitespace-nowrap overflow-hidden overflow-ellipsis"
                            style={{ maxWidth: '100%' }}
                          >
                            <b>Website name :</b> {values.website}
                          </span>
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    <div className="grid xl:grid-cols-2 sm:grid-cols-1 gap-4 mt-3">
                      <div>
                        <>
                          <div className="text-[#000] font-medium ml-1 mb-1">
                            Organization name
                          </div>
                          <Field
                            bordered={false}
                            autoComplete="off"
                            placeholder="Enter organization name"
                            type="text"
                            role="presentation"
                            className="w-full p-3 outline-1 outline-[#E5E8EB] font-sans h-12 flex items-center rounded-xl outline-none"
                            name="org_name"
                            value={values.org_name}
                            onChange={(e) => {
                              setFieldValue('org_name', e.target.value);
                              setOrgData({
                                ...orgData,
                                org_name: e.target.value,
                              });
                            }}
                          />
                        </>

                        {/* } */}
                        <ErrorMessage
                          name="org_name"
                          component="div"
                          className="text-red-500 mt-1"
                        />
                      </div>
                      {!isEditPage && (
                        <div>
                          <>
                            <div className="text-[#000] font-medium ml-1 mb-1">
                              Website name
                            </div>
                            <Field
                              bordered={false}
                              autoComplete="off"
                              placeholder="Enter website name"
                              type="text"
                              role="presentation"
                              className="w-full p-3 outline-1 outline-[#E5E8EB] font-sans h-12 flex items-center rounded-xl outline-none"
                              name="website"
                              value={values.website}
                              onChange={(e) => {
                                setFieldValue('website', e.target.value);
                                setOrgData({
                                  ...orgData,
                                  website: e.target.value,
                                });
                              }}
                              disabled={isEditPage}
                            />
                          </>
                          <ErrorMessage
                            name="website"
                            component="div"
                            className="text-red-500 mt-1"
                          />
                        </div>
                      )}
                      <div className="selector">
                        <div className="text-[#000] font-medium ml-1 mb-1">
                          EHR system
                        </div>
                        <SingleSelect
                          bordered={false}
                          autoComplete="off"
                          className="outline-1 outline-[#E5E8EB] outline-none p-1 font-sans h-12 flex items-center w-full focus:outline-none rounded-xl"
                          placeholder="Select EHR system"
                          options={ehrFilterOrganizationList.map((ehr) => ({
                            label: ehr,
                            value: ehr,
                          }))}
                          showSearch
                          name="ehr_id"
                          value={values.ehr_id}
                          onChange={(value) => {
                            setFieldValue('ehr_id', value);
                            setOrgData((prevOrgData) => ({
                              ...prevOrgData,
                              ehr_id: value,
                            }));
                          }}
                        />
                        <ErrorMessage
                          name="ehr_id"
                          component="div"
                          className="text-red-500 mt-1"
                        />
                      </div>
                      <div>
                        <div className="text-[#000] font-medium ml-1 mb-1">
                          Phone number
                        </div>
                        <PatternFormat
                          bordered={false}
                          autoComplete="off"
                          placeholder="Enter phone number"
                          type="phonenumber_text"
                          format="(###) ###-####"
                          className="w-full p-3 outline-1 outline-[#E5E8EB] font-sans h-12 flex items-center rounded-xl outline-none"
                          name="phone_data?.phone_text"
                          value={values?.phone_data?.phone_text}
                          onChange={(e) => {
                            setFieldValue(
                              'phone_data?.phone_text',
                              e.target.value
                            );
                            setOrgData((prevOrgData) => ({
                              ...prevOrgData,
                              phone_data: {
                                ...prevOrgData?.phone_data,
                                phone_text: e.target.value,
                              },
                            }));
                          }}
                        />
                      </div>
                      <div>
                        <div className="text-[#000] font-medium ml-1 mb-1">
                          Email
                        </div>
                        <Field
                          bordered={false}
                          autoComplete="off"
                          placeholder="Enter Email address"
                          type="text"
                          role="presentation"
                          className="w-full p-3 outline-1 outline-[#E5E8EB] font-sans h-12 flex items-center rounded-xl outline-none"
                          name="email_data.email_text"
                          value={values?.email_data?.email_text}
                          onChange={(e) => {
                            setFieldValue(
                              'email_data.email_text',
                              e.target.value
                            );
                            setOrgData((prevOrgData) => ({
                              ...prevOrgData,
                              email_data: {
                                ...prevOrgData.email_data,
                                email_text: e.target.value,
                              },
                            }));
                          }}
                        />
                      </div>
                      {!isEditPage && (
                        <div className="selector">
                          <div className="text-[#000] font-medium ml-1 mb-1">
                            Mirror organization
                          </div>

                          <SingleSelect
                            bordered={false}
                            autoComplete="off"
                            className="outline-1 outline-[#E5E8EB] outline-none p-1 font-sans h-12 flex items-center w-full focus:outline-none rounded-xl"
                            placeholder={
                              organizationLoading
                                ? 'Loading organizations...'
                                : organizationDropdown.length === 0
                                  ? 'No organizations available'
                                  : 'Select organization'
                            }
                            options={organizationDropdown}
                            showSearch
                            name="mirror_org_id"
                            value={values.mirror_org_id}
                            disabled={
                              organizationLoading ||
                              organizationDropdown.length === 0
                            }
                            onChange={(value) => {
                              setIsMirrorOrg(true);
                              dispatch(
                                getMirrorPractitionerDetails(
                                  value,
                                  setFieldValue,
                                  setOrgData,
                                  setJsonInput,
                                  autoPopulateTimeFields,
                                  setPreferredAreaCodes
                                )
                              );
                              setFieldValue('mirror_org_id', value);
                              setOrgData((prevOrgData) => ({
                                ...prevOrgData,
                                mirror_org_id: value,
                              }));
                            }}
                          />
                        </div>
                      )}
                      <div className="">
                        <div className="text-[#000] font-medium ml-1 mb-1">
                          Preferred area code
                        </div>
                        <div className="flex gap-2">
                          <div className="flex-1 relative">
                            <Field
                              bordered={false}
                              autoComplete="off"
                              placeholder="Enter 3-digit area code (e.g., 555)"
                              role="presentation"
                              className={`w-full p-3 outline-1 font-sans h-12 flex items-center rounded-xl outline-none transition-all duration-200 ${
                                inputValue.length === 3 &&
                                !isNaN(Number(inputValue))
                                  ? 'outline-[#00D090] outline-2'
                                  : 'outline-[#E5E8EB]'
                              }`}
                              name="preferred_phone_area_codes"
                              value={inputValue}
                              onChange={(e) => {
                                const value = e.target.value;

                                // Update input value and field value if length is less than or equal to 3
                                if (value.length <= 3) {
                                  setInputValue(value);
                                  setFieldValue(
                                    'preferred_phone_area_codes',
                                    value
                                  );
                                }

                                // Show or hide error message based on validation
                                // Navigate up to find the container that holds the error messages
                                const container =
                                  e.target.closest('.selector') ||
                                  e.target.parentElement.parentElement
                                    .parentElement;
                                const errMsgElement = container.querySelector(
                                  '[name="preferred_phone_area_codes_errMsg"]'
                                );
                                const requiredMsgElement =
                                  container.querySelector(
                                    '[name="preferred_phone_area_codes_requiredMsg"]'
                                  );

                                if (value.length === 0) {
                                  requiredMsgElement.classList.remove('hidden');
                                } else {
                                  requiredMsgElement.classList.add('hidden');
                                }

                                if (value.length > 3 || isNaN(Number(value))) {
                                  errMsgElement.classList.remove('hidden');
                                } else {
                                  errMsgElement.classList.add('hidden');
                                }
                              }}
                              onKeyDown={handleKeyDown}
                            />
                            {inputValue.length === 3 &&
                              !isNaN(Number(inputValue)) && (
                                <button
                                  type="button"
                                  onClick={() => {
                                    const newAreaCode = Number(
                                      inputValue.trim()
                                    );
                                    if (
                                      newAreaCode > 99 &&
                                      newAreaCode <= 999 &&
                                      (!preferredAreaCodes ||
                                        !preferredAreaCodes.includes(
                                          inputValue.trim()
                                        ))
                                    ) {
                                      setPreferredAreaCodes((prev) =>
                                        prev
                                          ? [...prev, inputValue.trim()]
                                          : [inputValue.trim()]
                                      );
                                      setInputValue('');
                                    }
                                  }}
                                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-green-500 text-sm font-medium hover:text-green-600 cursor-pointer underline"
                                >
                                  Add
                                </button>
                              )}
                          </div>
                        </div>
                        <div
                          className="hidden text-red-500 mt-1"
                          name="preferred_phone_area_codes_errMsg"
                        >
                          Code must be exactly 3 digits
                        </div>
                        <div
                          className="hidden text-red-500 mt-1"
                          name="preferred_phone_area_codes_requiredMsg"
                        >
                          Preferred area code is required
                        </div>
                        {(isEditPage || isMirrorOrg) && (
                          <div>
                            <div className="flex gap-1 flex-wrap">
                              {Array.isArray(preferredAreaCodes) &&
                                preferredAreaCodes.map((code, index) => (
                                  <div
                                    key={index}
                                    className="flex preferred-area-code mt-2 pl-3 pr-2 py-1"
                                  >
                                    {code}
                                    <button
                                      type="button"
                                      className="bg-[#ccc] rounded-full px-1 ml-2"
                                      onClick={() => handleRemoveCode(index)}
                                    >
                                      ✖
                                    </button>
                                  </div>
                                ))}
                            </div>
                          </div>
                        )}
                        {!isEditPage && !isMirrorOrg && (
                          <div className="flex gap-1 flex-wrap">
                            {Array.isArray(preferredAreaCodes) &&
                              preferredAreaCodes.map((code, index) => {
                                const numCode = Number(code);
                                if (numCode !== '') {
                                  return (
                                    <div
                                      key={index}
                                      className="flex preferred-area-code mt-2 pl-3 pr-2 py-1"
                                    >
                                      {numCode}
                                      <button
                                        type="button"
                                        className="bg-[#ccc] rounded-full px-1 ml-2"
                                        onClick={() => handleRemoveCode(index)}
                                      >
                                        ✖
                                      </button>
                                    </div>
                                  );
                                } else {
                                  return null;
                                }
                              })}
                          </div>
                        )}
                      </div>
                      <div className="selector">
                        <div className="text-[#000] font-medium ml-1 mb-1">
                          Frontegg plans
                        </div>

                        <SingleSelect
                          bordered={false}
                          autoComplete="off"
                          className="single-select font-sans w-full focus:outline-none rounded-xl"
                          placeholder="Select frontegg plans"
                          options={fronteggPlanOptions}
                          showSearch
                          dropdownMode="multiple"
                          name="frontegg_plan_ids"
                          value={values.frontegg_plan_ids}
                          onChange={(value) => {
                            setFieldValue('frontegg_plan_ids', value);
                            setOrgData((prevOrgData) => ({
                              ...prevOrgData,
                              frontegg_plan_ids: value,
                            }));
                          }}
                        />
                        <ErrorMessage
                          name="frontegg_plan_ids"
                          component="div"
                          className="text-red-500 mt-1"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="">
                  <div className="flex items-center text-lg font-semibold mb-2 text-[#000] mt-4">
                    Add address
                    <span
                      className="cursor-pointer ml-2"
                      onClick={addressToggleVisibility}
                    >
                      {flipicon}
                    </span>
                  </div>
                  {isExpandedAddress && (
                    <div className="grid xl:grid-cols-2 sm:grid-cols-1 gap-4 mt-5">
                      <div>
                        <div className="text-[#000] font-medium ml-1 mb-1">
                          Address 1
                        </div>
                        <Field
                          bordered={false}
                          autoComplete="off"
                          placeholder="Enter address 1"
                          type="text"
                          role="presentation"
                          className="w-full p-3 outline-1 outline-[#E5E8EB] font-sans h-15 flex items-center rounded-xl outline-none"
                          name="address.line_1"
                          value={values.address.line_1}
                          onChange={(e) => {
                            setFieldValue('address.line_1', e.target.value);
                            setOrgData((prevOrgData) => ({
                              ...prevOrgData,
                              address: {
                                ...prevOrgData.address,
                                line_1: e.target.value,
                              },
                            }));
                          }}
                        />
                      </div>
                      <div>
                        <div className="text-[#000] font-medium ml-1 mb-1">
                          Address 2
                        </div>
                        <Field
                          bordered={false}
                          autoComplete="off"
                          placeholder="Enter address 2"
                          type="text"
                          role="presentation"
                          className="w-full p-3 outline-1 outline-[#E5E8EB] font-sans h-15 flex items-center rounded-xl outline-none"
                          name="address.line_2"
                          value={values.address.line_2}
                          onChange={(e) => {
                            setFieldValue('address.line_2', e.target.value);
                            setOrgData((prevOrgData) => ({
                              ...prevOrgData,
                              address: {
                                ...prevOrgData.address,
                                line_2: e.target.value,
                              },
                            }));
                          }}
                        />
                      </div>
                      <div>
                        <div className="text-[#000] font-medium ml-1 mb-1">
                          Zipcode
                        </div>
                        <Field
                          bordered={false}
                          autoComplete="off"
                          placeholder="Enter zipcode number"
                          type="text"
                          role="presentation"
                          className="w-full p-3 outline-1 outline-[#E5E8EB] font-sans h-15 flex items-center rounded-xl outline-none"
                          name="address.zip"
                          value={values.address.zip}
                          onChange={(e) => {
                            setFieldValue('address.zip', e.target.value);
                            setOrgData((prevOrgData) => ({
                              ...prevOrgData,
                              address: {
                                ...prevOrgData.address,
                                zip: e.target.value,
                              },
                            }));
                          }}
                        />
                      </div>
                      <div>
                        <div className="text-[#000] font-medium ml-1 mb-1">
                          City
                        </div>
                        <Field
                          bordered={false}
                          autoComplete="off"
                          placeholder="Enter city name"
                          type="text"
                          role="presentation"
                          className="w-full p-3 outline-1 outline-[#E5E8EB] font-sans h-15 flex items-center rounded-xl outline-none"
                          name="address.city"
                          value={values.address.city}
                          onChange={(e) => {
                            setFieldValue('address.city', e.target.value);
                            setOrgData((prevOrgData) => ({
                              ...prevOrgData,
                              address: {
                                ...prevOrgData.address,
                                city: e.target.value,
                              },
                            }));
                          }}
                        />
                      </div>
                      <div>
                        <div className="text-[#000] font-medium ml-1 mb-1">
                          State
                        </div>
                        <SingleSelect
                          bordered={false}
                          autoComplete="off"
                          className="bg-white outline-1 outline-[#E5E8EB] outline-none p-1 font-sans h-12 flex items-center w-full focus:outline-none rounded-xl"
                          placeholder="Enter state name"
                          options={usStateOptions}
                          showSearch
                          name="address.state"
                          value={values.address.state}
                          onChange={(value) => {
                            setFieldValue('address.state', value);
                            setOrgData((prevOrgData) => ({
                              ...prevOrgData,
                              address: {
                                ...prevOrgData.address,
                                state: value,
                              },
                            }));
                          }}
                        />
                      </div>
                      <div>
                        <div className="text-[#000] font-medium ml-1 mb-1">
                          Country
                        </div>
                        <Field
                          bordered={false}
                          autoComplete="off"
                          placeholder="Enter country name"
                          type="text"
                          role="presentation"
                          className="w-full p-3 outline-1 outline-[#E5E8EB] font-sans h-15 flex items-center rounded-xl outline-none"
                          // value="USA"
                          name="address.country"
                          value={values.address.country}
                          onChange={(e) => {
                            setFieldValue('address.country', e.target.value);
                            setOrgData((prevOrgData) => ({
                              ...prevOrgData,
                              address: {
                                ...prevOrgData.address,
                                country: e.target.value,
                              },
                            }));
                          }}
                          disabled
                        />
                      </div>
                    </div>
                  )}
                </div>
              </>
            </Form>
          </>
        )}
      </Formik>
    );
  }
);
